module.exports = __webpack_public_path__ + "static/media/kafedra_logo.cdab7229.png";